import { Controller } from '@hotwired/stimulus'

const DEFAULT_DATE_FORMAT = 'Y-m-d'
const PICKER_TOKENS = { Y: 'yyyy', m: 'mm', d: 'dd' }

export default class extends Controller {
    static values = {
        datepickerLanguage: String,
        datepickerEndDate: String,
        dateFormat: String,
        pricingDate: String,
        snapshotUrlTemplate: String,
        availableDates: Array
    }

    connect() {
        this.#initDatePicker()
    }

    showDatepicker() {
        $(this.element).find('.date-picker-wrapper')
            .attr('data-state', 'show')
            .find('input')
            .removeAttr('disabled')
    }

    loadSnapshot() {
        const $element = $(this.element)
        const pickedDate = this.#getPickedDate()
        if (!pickedDate) {
            return
        }
        const formatted = this.#formatDate(pickedDate)
        if (!this.availableDatesValue.includes(formatted)) {
            return
        }
        const syncedPricingDate = this.pricingDateValue
        $element.addClass('loading')
        $.ajax({
            method: 'GET',
            url: this.snapshotUrlTemplateValue.replace('__DATE__', formatted),
        })
            .done((response) => {
                $('#js-us-metal-price-snapshot').html(response.content.template)
                const content = response.content || {}
                if (Array.isArray(content.availableDates) && content.availableDates.length > 0) {
                    this.availableDatesValue = content.availableDates
                }
                this.pricingDateValue = content.snapshotDate || formatted
                this.#initDatePicker()
            })
            .fail(() => {
                $element.find('.datepicker-to').val(this.#formatDisplayDate(syncedPricingDate))
            })
            .always(() => {
                $element.removeClass('loading')
            })
    }

    #getPickedDate() {
        const $pickerTo = $(this.element).find('.datepicker-to')
        return $pickerTo.datepicker('getDate')
    }

    #initDatePicker() {
        const $element = $(this.element)
        const $pickerTo = $element.find('.datepicker-to')
        const $triggerTo = $pickerTo.next()
        const $endDate = this.#parseDisplayDate(this.datepickerEndDateValue)
        const datepickerConfig = {
            language: this.datepickerLanguageValue,
            format: this.#pickerFormat(),
            endDate: $endDate,
            filter: (date, view) => {
                if (view !== 'day') {
                    return
                }
                return this.availableDatesValue.includes(this.#formatDate(date))
            }
        }

        $pickerTo.datepicker($.extend({}, datepickerConfig, {
            autoHide: true,
            trigger: $triggerTo
        }))

        $pickerTo
            .off('pick.datepicker')
            .on('pick.datepicker', () => {
                $pickerTo[0].dispatchEvent(new Event('change', { bubbles: true }))
            })

        $pickerTo.val(this.#formatDisplayDate(this.pricingDateValue))
    }

    #formatDate(date) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }

    #dateFormat() {
        return this.dateFormatValue || DEFAULT_DATE_FORMAT
    }

    #pickerFormat() {
        return this.#dateFormat().replace(/[Ymd]/g, (token) => PICKER_TOKENS[token])
    }

    #formatDisplayDate(isoDate) {
        const [year, month, day] = isoDate.split('-')
        const parts = { Y: year, m: month, d: day }

        return this.#dateFormat().replace(/[Ymd]/g, (token) => parts[token])
    }

    #parseDisplayDate(displayDate) {
        const format = this.#dateFormat()
        const parts = { Y: '', m: '', d: '' }
        let index = 0

        for (let i = 0; i < format.length; i++) {
            const token = format[i]
            if (token in PICKER_TOKENS) {
                const length = token === 'Y' ? 4 : 2
                parts[token] = displayDate.slice(index, index + length)
                index += length
            } else {
                index += 1
            }
        }

        return new Date(Number(parts.Y), Number(parts.m) - 1, Number(parts.d))
    }
}
